import { notification, message } from 'antd';
import { ServerAddress, ServerChatAddress } from './urls';
import Cookies from 'universal-cookie';
// import CryptoJS from 'crypto-js'

const ConnectServer = async (URL: any, method: any, ContentType: any, Params: any, ...props: any) => {
    const cookies = new Cookies();
    let headers = new Headers();
    const openNotification = (title: any, message: any) => {
        notification.warning({
            message: title,
            description: message,
            placement: 'bottomLeft',
        });
    };


    const cookieToken = await cookies.get('access_token')
    // var bytes, originalText;

    // if (cookieToken) {
    //     bytes = CryptoJS?.AES?.decrypt(cookieToken, 'secret key 123');
    //     originalText = bytes?.toString(CryptoJS?.enc?.Utf8);
    // }

    if (props[0]?.basicType == 1) {
        headers.append("Authorization", "Basic " + window.btoa(props[0]?.username + ":" + props[0].password));
    }
    else if (cookieToken) {
        headers.append("Authorization", "Bearer " + cookieToken.toString());
    }
    // headers.append("Authorization", "Bearer " +"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNjYyOTU5NDYyLCJleHAiOjE2NjU1NTE0NjJ9.GkuJiuDFkC4GKGRwbqBZ1I0Ev7eDeLq1dePSi1m-YUs");

    if (ContentType !== null)
        headers.append("Content-Type", ContentType);

    return new Promise((resolve, reject) => {
        fetch((!(props[0]?.chatUrl) ?ServerAddress  : ServerChatAddress) + URL, {
            method: method,
            headers: headers,
            body: Params
        }).then(async (response) => {
          
            if (response.status === 401) {
                // localStorage.clear()
                // reject({status: "FAILED",message: { private: null, public: <div>توکن شما منقضی شده است <br />  در حال انتقال به صفحه ورود</div> }})
                // openNotification("در حال انتقال به صفحه ورود", "توکن شما منقضی شده است")
                // setTimeout(() => {window.location.pathname = "/"}, 2000)
            }
            if (response.status >= 300) {
                const jsonData = await response.json()
                reject(jsonData)
                openNotification("", jsonData?.message)
            }

            else {
                const jsonData = await response.json()
                if (jsonData) {
                    resolve(jsonData)
                } else reject(reject({ status: "FAILED", message: { private: null, public: ".دوباره تلاش کنید" } }))
            }
        }).catch((error) => { 
            
            reject({ status: "FAILED", message: { private: null, public: ".دوباره تلاش کنید" } }) });
    })
}

export default ConnectServer

